<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="none">
    <path
        stroke="#020621"
        stroke-width="1.2"
        d="m24.6789 22.4133.0109-.0018c.2993 0 .5876-.1221.7968-.3373 3.7149-3.8277 5.4086-5.5761 5.4313-5.6044.493-.5816 1.3671-.6554 1.9484-.1641.5821.4932.6558 1.3683.1619 1.9535l-6.1962 7.424c-.9051.8706-2.0931 1.3492-3.3483 1.3492h-9.1843c-.9005 0-1.7519.3455-2.3986.9717l-1.5455 1.5661-5.10921-5.124.65492-1.2981c1.26526-2.3793 3.63933-3.7311 6.59189-3.7311 1.0579 0 2.0812.2133 3.0408.6335.0874.0392.182.0593.2766.0593h7.8453c.7586 0 1.399.6271 1.3817 1.4138-.0164.7585-.6586 1.3556-1.4153 1.3556h-7.9818"
    />
    <path
        stroke="#020621"
        stroke-width="1.2"
        d="M3.8321 24.0108c.2274-.2279.5776-.2698.85503-.0966.12007.0729-.22377-.2407 5.98427 5.9709.2765.2771.2611.7174.0037.9763l-2.29497 2.2662c-.31018.3054-.80773.3026-1.11427-.0064l-5.6814-5.7375c-.30562-.309-.30563-.8077.00182-1.1149l2.24582-2.258ZM12.3779 9.17769c0 4.31281 3.5092 7.82221 7.8227 7.82221s7.8218-3.5094 7.8218-7.82221c0-4.3128-3.5083-7.82222-7.8218-7.82222-4.3135 0-7.8227 3.50942-7.8227 7.82222Z"
        clip-rule="evenodd"
    />
    <path
        stroke="#020621"
        stroke-width="1.2"
        d="M18.7778 10.5668v.203c0 .745.7123 1.3489 1.591 1.3489.8787 0 1.591-.6039 1.591-1.3489 0-.203 0-1.10993-1.597-1.58271-1.597-.47277-1.585-1.35003-1.585-1.55303 0-.74498.7123-1.3489 1.591-1.3489.8787 0 1.591.60392 1.591 1.3489v.203M20.438 4.91113v1.37408"
    />
    <path
        stroke="#020621"
        stroke-width="1.2"
        d="M20.438 12.1191v1.3259-1.3259Z"
        clip-rule="evenodd"
    />
</svg>
